module.exports = __webpack_public_path__ + "static/media/Card_Reader.451d8bfb.gif";